/* pageTop
========================================================= */
export function pageTop($) {
  const topBtn = $('#pagetop');
  topBtn.hide();

  // スクロールが200に達したらボタン表示
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 200) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });
}

/* anchorLink
========================================================= */
export function anchorLink() {
  // ▼ クリック時のスムーススクロール
  document.addEventListener('click', function (e) {
    const pagetop = e.target.closest('#pagetop');
    if (pagetop) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      return;
    }

    const link = e.target.closest('a[href]');
    if (!link) return;
    if (link.target === '_blank') return;

    const href = link.getAttribute('href');
    if (!href) return;

    const url = new URL(href, window.location.href);

    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) {
      return;
    }

    const hash = url.hash;
    if (hash === '#' || hash === '#0') return;

    const targetEl = document.querySelector(hash);
    if (!targetEl) return;

    e.preventDefault();

    const isPc = window.matchMedia('(min-width: 768px)').matches;
    const headerHeight = isPc ? 106 : 0;

    const targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset - headerHeight;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  });

  // ▼ ページ読み込み時ハッシュ付きなら遷移後に調整
  window.addEventListener('load', function () {
    const hash = window.location.hash;
    if (!hash) return;
    if (hash === '#top' || hash === '#pagetop' || hash === '#page-top') {
      return;
    }

    const targetEl = document.querySelector(hash);
    if (!targetEl) return;

    const isPc = window.matchMedia('(min-width: 768px)').matches;
    const headerHeight = isPc ? 106 : 0;

    setTimeout(function () {
      const targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });
    }, 0);
  });
}
